module.exports = __webpack_public_path__ + "img/kehu_yinzuojiudian.78674a89.png";